import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import type { SelectionState } from '@/infra/selection-state'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { match } from '@/utils/pattern-match-util'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { JobsTable } from '@/features/jobs/list/components/JobManagement/JobsTable'
import { JobsTableRowContainer } from '@/features/jobs/list/components/JobManagement/JobsTable/JobsTableRow/JobsTableRowContainer'

export interface JobsTableContainerProps {
  vm: JobManagementViewModel
}

export const JobsTableContainer = observer(function JobsTableContainer({
  vm,
}: JobsTableContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <JobsTable
      corporateMode={shellInfo.corporateMode}
      isEmpty={vm.showEmptyView}
      columns={vm.columnsVm.filteredColumns
        .filter((col) => col.visible)
        .map((col) => ({
          id: col.id,
          header: col.header,
          sortable: col.sortable,
          sortOrder: vm.getSortOrder(col),
          onSort: (newSort) => vm.setSortOrder(col, newSort),
        }))}
      allSelected={match<SelectionState, boolean | 'indeterminate'>(
        vm.selectionVm.jobActionSelectionState,
        {
          AllSelected: () => true,
          NoneSelected: () => false,
          SomeSelected: () => 'indeterminate',
        },
      )}
      onToggleAllSelected={vm.selectionVm.toggleAllSelectedJobsForActions}
      isSelectAllPending={vm.selectionVm.isSelectAllPending}
      scrollLoader={
        <InfiniteScrollLoaderContainer scrollProvider={vm.searcher.scroller} />
      }
      onClearSearchFilter={vm.searcher.clearFilters}
      onSetJobScope={
        vm.searcher.scope === 'Mine' ? vm.jobListPageVm.showAllJobs : undefined
      }
    >
      {vm.filteredJobs.map((job) => (
        <JobsTableRowContainer vm={vm} job={job} key={job.id} />
      ))}
    </JobsTable>
  )
})
